import React, { type MouseEvent } from 'react';
import key from 'weak-key';

import FileEntry from './file-entry';
import CardTextSearch from './card-textsearch';
import { getTranslation } from '../../utils/config';
import type { IItem } from '../../types';

type CardExpandedProps = {
  groupId: number;
  taggingProduct: Array<string>;
  text: string;
  groupAttributes: Array<{ facetname: string; displayname: string }>;
  cardData: Array<IItem | undefined>;
  loginRequired: boolean;
  handleDownload: (e: MouseEvent<HTMLAnchorElement>) => void;
  toggleExpanded: () => void;
  isEmpty: boolean;
};

export default function CardExpanded({
  groupId,
  taggingProduct,
  text,
  groupAttributes,
  cardData,
  loginRequired,
  handleDownload,
  toggleExpanded,
  isEmpty,
}: CardExpandedProps): React.ReactElement {
  const expandTaggingProducts =
    taggingProduct && taggingProduct.length > 1 && !text && cardData.length <= 3;
  return (
    <div className="df-list-module-detail">
      <div className="section-content">
        <div className="container">
          <div className="row flex">
            <div className="col col-12">
              {(text || cardData.length > 3) && (
                <span className="df-list-module-detail__header">
                  <b>{getTranslation('further_information')}</b>
                </span>
              )}
              {text && (
                <div className="df-text df-text-half-width">
                  <div dangerouslySetInnerHTML={{ __html: text }} />
                </div>
              )}
            </div>
            {cardData.length > 3 && (
              <div className="col col-12">
                <table className="df-list-module__table df-list-module__table-detail">
                  <thead>
                    <tr>
                      {groupAttributes?.map((attribute) => (
                        <th key={attribute.displayname}>{attribute.displayname}</th>
                      ))}
                      <th> </th>
                      <th> </th>
                    </tr>
                  </thead>
                  <tbody>
                    {cardData.map((file) =>
                      file ? (
                        <FileEntry
                          key={key(file)}
                          attributes={groupAttributes}
                          loginRequired={loginRequired}
                          handleDownload={handleDownload}
                          hasShare
                          groupId={groupId}
                          {...file}
                        />
                      ) : null,
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          {taggingProduct && taggingProduct.length > 1 && (
            <div className="row flex">
              <div className="col col-12">
                <CardTextSearch
                  taggingProduct={taggingProduct}
                  expandInitially={expandTaggingProducts}
                  groupId={groupId}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {!isEmpty && (
        <button
          type="button"
          className="df-btn-special__close"
          onClick={toggleExpanded}
          aria-label={getTranslation('less_info')}
        ></button>
      )}
    </div>
  );
}
